module.exports = __webpack_public_path__ + "static/media/TandC.be49c4c7.svg";